<section class="card">

    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">MBP-3  Register of Investment not held in its own name by the company</strong>
      </span>
      <span style="float:right">
        <!-- <a routerLink="/mbp3/add"> -->
          <button (click)="add()" class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button" [appHasPermission]="{'Url': '/register/mbp3List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp3List'}">
            <i class="fa fa-plus"></i>&nbsp;Add</button>
        <!-- </a> -->
      </span>
      <span style="float:right">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" style="margin-right: 8px;" (click)="generateOutput()" type="button">
            <span>
              <i class="fa fa-save"></i>&nbsp;Generate Output </span>
          </button>
        </span>
    </div>
  
    <!-- Date Filter  -->
    <section class="card search-box">
      <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search <span class="pull-right"><i
            class="fa fa-filter" aria-hidden="true"></i></span> </div>
      <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
        <div class="row">
          <div class="col-lg-12">
            <div class="row">
              
              <div class="col-lg-4 col-md-4 col-sm-4">
                <label>Investment held by</label>
                <select class="form-control" style="padding:6px;" [(ngModel)]="investmentHeldBy">
                  <option value="" [selected]="true">Select</option>
                          <option value="Person">Person</option>
                          <option value="Depository">Depository</option>
                </select>
              </div>
              
              <div class="form-group col-lg-4 col-md-4 col-sm-4">
                <label>Name
                </label>
                <input type="text" class="form-control" [(ngModel)]="nameOfPerson">
              </div>
  
              <div class="col-lg-4 col-md-4 col-sm-4">
                <label>Date of the board resolution authorizing such investment</label>
                <div class="input-group" (click)="$event.stopPropagation()">
                  <input id="dateOfBoardResolution" class="form-control" style="padding:6px;z-index: 0;"
                    placeholder="dd-mm-yyyy" name="dateOfBoardResolution" ngbDatepicker #cesDate="ngbDatepicker"
                    (click)="cesDate.toggle()" [(ngModel)]="dateOfBoardResolution">
                  <button class="input-group-addon" (click)="cesDate.toggle()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                </div>
              </div>
  
  
  
              <div class="col-md-4">
                <!-- <label>Date of disposal</label> -->
                <!-- <label>From</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                  From :&nbsp;
                  <input id="dateOfDisposal" class="form-control" [minDate]="futureToDate"
                    style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfDisposal" ngbDatepicker
                    #ab="ngbDatepicker" (click)="ab.toggle();bc.close()" [(ngModel)]="dateOfDisposal">
                  <button class="input-group-addon" (click)="ab.toggle();bc.close()" type="button">
                    <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                  </button>
                
                </div>
              </div>
  
  
              <div class="col-md-4">
                <!-- <label>Date of investment</label> -->
                <!-- <label>To</label> -->
                <br>
                <div class="input-group" (click)="$event.stopPropagation()">
                
                   To :&nbsp;
                  <input id="dateOfInvestment" class="form-control" [minDate]="futureToDate"
                  style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dateOfInvestment" ngbDatepicker
                  #bc="ngbDatepicker" (click)="bc.toggle();ab.close()" [(ngModel)]="dateOfInvestment">
                <button class="input-group-addon" (click)="bc.toggle();;ab.close()" type="button">
                  <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                </button>
                </div>
              </div>
  
  
  
  
              <div class="form-group col-lg-2 col-md-2 col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearch()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                    (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Date filter End -->
  
    <div class="card-block datatable-card-block">
      <div class="row">
        <div class="col-md-12">
          <div class="margin-bottom-50">
            <div class="table-responsive">
              <table datatable [dtOptions]="dtOptionsOfMbp" [dtTrigger]="dtTriggerMbp"
                class="table table-hover compact cell-border nowrap stripe" id="directormasterMbp3Table"
                style="cursor: pointer;">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Investment held by</th>
                    <th>Date of the board resolution <br> authorizing such investment</th>
                    <th style="display: none">Date of the board resolution authorizing such investment</th>
  
                    <th>Date of Disposal</th>
                    <th style="display: none">Date of Disposal</th>
  
                    <th>Date of investment</th>
                    <th style="display: none">Date of investment</th>
                    <th class="actionclass">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let director of registerDirectorList;let i=index">
                    <td tabindex="1">{{director.nameOfThePersonInvestment}}</td>
                    <td tabindex="1">{{director.investmentHeldBy}}</td>
                    <td>
                        <span style="display: none">{{director.dateOfBoardResolution | date : "yMMdd"}}</span>
                        {{director.dateOfBoardResolution | date : "dd-MM-y"}}
                      </td>
                      <td style="display: none">
                        {{director.dateOfBoardResolution | date : "dd-MM-y"}}
                      </td>
  
                      <td>
                        <span style="display: none">{{director.dateofdisposal | date : "yMMdd"}}</span>
                        {{director.dateofdisposal | date : "dd-MM-y"}}
                      </td>
                      <td style="display: none">
                        {{director.dateofdisposal | date : "dd-MM-y"}}
                      </td>
  
                      <td>
                        <span style="display: none">{{director.dateOfInvestment | date : "yMMdd"}}</span>
                        {{director.dateOfInvestment | date : "dd-MM-y"}}
                      </td>
                      <td style="display: none">
                        {{director.dateOfInvestment | date : "dd-MM-y"}}
                      </td>
  
                      
  
                    <td style='white-space: nowrap'>
                      <a>
                        <button type="button" (click)="editMbpDetails(director._id)" class="btn-sm btn btn-warning" [appHasPermission]="{'Url': '/register/mbp3List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp3List'}">
                          <span class="fa fa-pencil"></span>
                        </button>
                      </a>
                      <button type="button" class="btn-sm btn btn-danger" (click)="confirmDelete(director._id)" [appHasPermission]="{'Url': '/register/mbp3List/edit?goveva=true&email=', 'method':'put', 'menu': 'mbp3List'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <!-- </div> -->
    <!-- </div> -->
  
  </section>
  
  <div class="modal fade" id="deleteConfirm" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete MBP-3 details?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger" (click)="deleteMbpDetail()">
            <i class="fa fa-check"></i>&nbsp;Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>&nbsp;No
          </button>
        </div>
      </div>
    </div>
  </div>
  
  <app-alert></app-alert>